import { Drawer } from 'antd';
import type { DrawerProps } from 'antd';
import React from 'react';

/**
 * AppDrawer Component
 *
 * Ant Design Drawer wrapper following Atomic Design principles.
 * Extends all Ant Design Drawer props.
 *
 * Note on sizing: antd v6 replaced `width` / `height` with `size`, which takes
 * `'default' | 'large'`, a number, or any CSS length (`'min(1380px, 98vw)'`).
 * Use `size`; `width` still works but logs a deprecation warning.
 */

export type AppDrawerProps = DrawerProps;

const AppDrawer: React.FC<AppDrawerProps> = props => {
  return <Drawer {...props} />;
};

AppDrawer.displayName = 'AppDrawer';

export default AppDrawer;
